import { useEffect, useState } from "react";
import { END_POINTS } from "../../Helper/Constant";
import { getApiRequest } from "../../services/getApiRequest";
import { postApiRequest } from "../../services/postApiRequest";

export const DEFAULT_ALLOWED_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];
export const DEFAULT_BLOCKED_EMOJIS = ["🖕", "💩", "🐷", "🐖", "🐽"];

let cachedEmojis = null;
let cachedBlockedEmojis = null;
let inflight = null;

const toEmojiList = (list) =>
  Array.isArray(list) ? list.filter(Boolean) : null;

export const getBlockedEmojis = () =>
  cachedBlockedEmojis || DEFAULT_BLOCKED_EMOJIS;

export const fetchAllowedEmojis = async () => {
  if (Array.isArray(cachedEmojis) && cachedEmojis.length) {
    return cachedEmojis;
  }
  if (inflight) return inflight;

  inflight = getApiRequest(END_POINTS.CHAT_REACTIONS_ALLOWED_EMOJIS)
    .then((response) => {
      const payload = Array.isArray(response?.allowedEmojis)
        ? response
        : response?.data;
      const list = toEmojiList(payload?.allowedEmojis);
      if (!list) throw new Error("Invalid allowed emojis response");

      cachedEmojis = list;
      cachedBlockedEmojis =
        toEmojiList(payload?.blockedEmojis) || DEFAULT_BLOCKED_EMOJIS;
      return cachedEmojis;
    })
    .catch(() =>
      cachedEmojis && cachedEmojis.length ? cachedEmojis : DEFAULT_ALLOWED_EMOJIS
    )
    .finally(() => {
      inflight = null;
    });

  return inflight;
};

export const setAllowedEmojisCache = (emojis = []) => {
  cachedEmojis = Array.isArray(emojis) ? emojis.filter(Boolean) : [];
  return cachedEmojis;
};

export const saveAllowedEmojis = async (emojis = []) => {
  const response = await postApiRequest(END_POINTS.CHAT_REACTIONS_ALLOWED_EMOJIS, {
    emojis,
  });
  const list = Array.isArray(response?.allowedEmojis)
    ? response.allowedEmojis
    : emojis;
  return setAllowedEmojisCache(list);
};

const useAllowedEmojis = () => {
  const [allowedEmojis, setAllowedEmojis] = useState(cachedEmojis || []);
  const [blockedEmojis, setBlockedEmojis] = useState(getBlockedEmojis);
  const [loading, setLoading] = useState(!cachedEmojis);

  useEffect(() => {
    let mounted = true;
    setLoading(!cachedEmojis);
    fetchAllowedEmojis().then((list) => {
      if (mounted) {
        setAllowedEmojis(list);
        setBlockedEmojis(getBlockedEmojis());
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { allowedEmojis, blockedEmojis, loading };
};

export default useAllowedEmojis;
